import type {ReactNode} from 'react';
import {cn, FramedIcon} from '@chekinapp/ui';

type Props = {
  icon: ReactNode;
  children: ReactNode;
  className?: string;
};

function ModalPointRow({icon, children, className}: Props) {
  return (
    <div
      className={cn(
        'flex items-start gap-[11px] text-[14px] leading-[18px] text-[var(--chekin-text-secondary)]',
        '[&_b]:font-semibold [&_b]:text-[var(--chekin-color-brand-navy)]',
        className,
      )}
    >
      <FramedIcon size={30} shape="soft" className="[&_svg]:size-[15px]">
        {icon}
      </FramedIcon>
      <span className="min-w-0">{children}</span>
    </div>
  );
}

export {ModalPointRow};
